import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";
import TableComponent from "./TableComponet";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI413_2 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "actualPotential",
      title:
        "i. Disclosure 413-2 Operations with significant actual and potential negative impacts on local communities",
      fields: [
        {
          fieldName: "location",
          title: "Location",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);

  const inputData1 = [
    {
      fieldName: "negativeImpactsOnLocalCommunities",
      title:
        "ii. Describe the significant actual and potential negative impacts of operations in these locations.",
      fields: [
        {
          fieldName: "location",
          title: "Location",
          type: "text",
          //   options: [
          //     "Full-Time",
          //     "Part-Time",
          // //   ],
          // options: tables[0]?.rows?.map((row) => row.location) || [],
          placeholder: "Type Here",
        },
        {
          fieldName: "actualnegativeImpact",
          title: "Actual Negative Impact",
          type: "text",
          placeholder: "Type Here",
        },
        {
          fieldName: "potentialnegativeImpact",
          title: "Potential Negative Impact",
          type: "text",
          placeholder: "Type Here",
        },
      ],
    },
  ];

  const [tables1, setTables1] = React.useState([]);

  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [formData, setFormData] = useState({
    locationOperation: "",
  });
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        const data1 =
          response.data.data.GRI400.operationsWithNegativeImpacts || {};
        setData(data1);
        setFormData({
          locationOperation: data1?.locationOperation || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // In GRI413_2 component
  useEffect(() => {
    // Get the first table (actualPotential)
    const firstTable = tables.find((t) => t.fieldName === "actualPotential");
    if (!firstTable) return;

    const firstTableRows = firstTable.rows || [];

    // Find the second table (negativeImpactsOnLocalCommunities)
    const secondTableIndex = tables1.findIndex(
      (t) => t.fieldName === "negativeImpactsOnLocalCommunities"
    );
    const secondTable =
      secondTableIndex !== -1 ? tables1[secondTableIndex] : null;

    // Generate new rows for the second table based on the first table's rows
    const newSecondRows = firstTableRows.map((firstRow, index) => {
      const location = firstRow.location || "";
      const existingRow = secondTable?.rows?.[index] || {};

      // Preserve existing data and update the location
      return {
        ...existingRow,
        location: location,
        actualnegativeImpact: existingRow.actualnegativeImpact || "",
        potentialnegativeImpact: existingRow.potentialnegativeImpact || "",
      };
    });

    // Update the second table's rows if there are changes
    let newTables1 = [...tables1];
    if (secondTable) {
      newTables1[secondTableIndex] = {
        ...secondTable,
        rows: newSecondRows,
      };
    } else {
      newTables1.push({
        fieldName: "negativeImpactsOnLocalCommunities",
        rows: newSecondRows,
      });
    }

    if (JSON.stringify(newTables1) !== JSON.stringify(tables1)) {
      setTables1(newTables1);
    }
  }, [tables]); // Trigger when the first table changes

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (!formData.locationOperation) {
      newErrors.locationOperation = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // const isTableValid = validateTable(inputData, tables, setTabErrors);
      // const isTableValid1 = validateTable(inputData1, tables1, setTabErrors1);

      // if (
      //   // !validateForm()  ||
      //   !isTableValid ||
      //   !isTableValid1
      // ) {
      //   return;
      // }

      let transformedData = restructureData(tables);
      let transformedData1 = restructureData(tables1);

      const payload = {
        type: "GRI400",
        submitted413_2: true,
        operationsWithNegativeImpacts: {
          ...formData,
          ...transformedData,
          ...transformedData1,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/414-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/414-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>413 : Local Communities</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        413-2 : Operations with significant actual and potential negative
        impacts on local communities
      </p>
      <Box>
        <SectionHeading text="a. Identify the operations with significant actual and potential negative impacts on local communities." />

        <CustomTextField
          value={formData.locationOperation}
          onChange={(e) =>
            handleInputChange("locationOperation", e.target.value)
          }
          error={errors.locationOperation}
          helperText={errors.locationOperation}
          disabled={disabled}
        />

        <Box sx={{ marginTop: hide ? "1rem" : "-0.5rem" , }}>
          <DynamicTable
            inputData={inputData}
            tables={tables}
            data={data}
            setTables={setTables}
            errors={tabErrors}
            setErrors={setTabErrors}
            disabled={disabled}
            hide={hide}
          />
        </Box>

        <Box sx={{ marginTop: hide ? "1rem" : "-2rem" }}>
          <TableComponent
            inputData={inputData1}
            tables={tables1}
            data={data}
            setTables={setTables1}
            errors={tabErrors1}
            setErrors={setTabErrors1}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI413_2;
